export type MonitorCoverage = { total: number; confirmed: number };
export type MonitorStatus = { timezone: string; monitor_can_confirm_data: boolean; coverage?: MonitorCoverage };

export function coverageText(coverage?: MonitorCoverage) {
  if (!coverage || !coverage.total) return "Нет подтверждённых источников наблюдения";
  return `Подтверждено источников: ${coverage.confirmed} из ${coverage.total}`;
}

const explanations: Record<string, string> = {
  "Taker order history is verified; maker order traffic is not yet verified.": "История taker-ордеров подтверждена. Поток maker-ордеров пока не подтверждён: откройте соответствующий раздел биржи в профиле и проверьте поступление данных.",
  "No verified P2P order response has arrived in the last two minutes.": "За последние две минуты не получены подтверждённые ответы с P2P-ордерами. Проверьте, открыт ли нужный раздел биржи и есть ли соединение.",
};

export function diagnosticExplanation(message: string) {
  return explanations[message] ?? ([...message].every((character) => character.charCodeAt(0) <= 127) ? "Источник требует проверки. Проверьте соединение и открытый раздел биржи; технические подробности приведены ниже." : message);
}
